import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/image/image.png'


const _hoisted_1 = { class: "layout-header" }
const _hoisted_2 = { class: "menus" }
const _hoisted_3 = { class: "toolbar_layout" }
const _hoisted_4 = { class: "toolbar" }
const _hoisted_5 = { class: "notice" }
const _hoisted_6 = { class: "management" }
const _hoisted_7 = { style: {"margin-left":"8px","max-width":"64px","font-size":"14px","font-weight":"400","color":"#fff","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis","line-height":"22px"} }
const _hoisted_8 = { class: "user-menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_BellOutlined = _resolveComponent("BellOutlined")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_avatar = _resolveComponent("a-avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "logo_content" }, [
      _createElementVNode("img", {
        class: "logo",
        src: _imports_0
      })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_menu, {
        class: "top-bar-menu",
        selectedKeys: _ctx.current,
        "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.current) = $event)),
        items: _ctx.items,
        mode: "horizontal",
        theme: "dark",
        onClick: _ctx.topbar_change
      }, null, 8, ["selectedKeys", "items", "onClick"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_BellOutlined, { style: {"color":"#fff","width":"18px","font-size":"18px"} })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_a_dropdown, {
            placement: "bottomRight",
            overlayStyle: {'background':'#0F172A'},
            trigger: "['click']"
          }, {
            overlay: _withCtx(() => [
              _createVNode(_component_a_menu, { style: {"background":"#0F172A"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_menu_item, {
                    key: "1",
                    style: {"color":"white"}
                  }, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createElementVNode("a", { href: "#/libs" }, " Compl-Libs ", -1)
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "management-icon",
                onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
              })
            ]),
            _: 1
          })
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "language" }, [
          _createElementVNode("div", { class: "management-icon language-icon" })
        ], -1)),
        _createVNode(_component_a_dropdown, {
          trigger: ['click'],
          "overlay-style": {background:'#0F172A'}
        }, {
          overlay: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_a_menu, { style: {"background":"black"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_menu_item, { key: "1" }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        style: {"color":"#fff"},
                        href: "javascript:void(0)",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.logOut && _ctx.logOut(...args)))
                      }, "Sign out")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "user_info",
              onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
            }, [
              (_ctx.userInfo.name != '')
                ? (_openBlock(), _createBlock(_component_a_avatar, {
                    key: 0,
                    style: _normalizeStyle(_ctx.avatar_style),
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.userInfo.name[0].toUpperCase()), 1)
                    ]),
                    _: 1
                  }, 8, ["style"]))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.userInfo.name), 1)
            ])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}